var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-column" }, [
    _c(
      "div",
      [
        _c(
          "el-tree",
          {
            ref: "tree",
            attrs: {
              data: this.filter.inputs.choices.options,
              "show-checkbox": "",
              "node-key": "id",
              "default-checked-keys": this.choices,
              props: _vm.defaultProps
            },
            on: { check: _vm.handleCheckChange },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var node = ref.node
                  var data = ref.data
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: data.name,
                            placement: "top"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(data.name))])]
                      )
                    ],
                    1
                  )
                }
              }
            ])
          },
          [_vm._v(");\n              \n            ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }